module.exports = require("@tiptap/extension-placeholder");